import { useCompanyRegionExposure } from '@terminal/react-query-hooks/knowledge-graph/useKnowledgeGraph';
import React from 'react';

import { GeographicExposureTable } from '../components/GeographicExposureTable';
import { useGeographicDrawer } from '../drawers/useGeographicDrawer';

export interface RegionalExposureTabProps {
  entityTag: string;
}

export const RegionalExposureTab = ({
  entityTag,
}: RegionalExposureTabProps) => {
  const { openRegion } = useGeographicDrawer({ entityTag });

  const { data, isFetching } = useCompanyRegionExposure({
    entityTag: entityTag,
    enabled: !!entityTag,
  });

  return (
    <GeographicExposureTable
      mode="region"
      data={data}
      isFetching={isFetching}
      onRowClick={openRegion}
    />
  );
};
